export const DISABLED_FOR_CHINA = ['NEWS', 'CHROMEEXTENSION', 'MARKET_SIZE_ESTIMATE'];
export const ACCESS_DENI_MESSAGE = 'You don\'t have access to update this option. Please contact your manager.';


